{
  "status": {
    "IN_SERVICE": "في الخدمة",
    "OUT_OF_ORDER": "معطّلة",
    "REMOVED": "أُزيلت",
    "REPLACED": "استُبدلت"
  },
  "condition": {
    "GOOD": "جيدة",
    "FAIR": "مقبولة",
    "POOR": "سيئة"
  },
  "yes": "نعم",
  "no": "لا",
  "notSet": "غير مسجّل",
  "onSite": "في الموقع نفسه",
  "wholeSite": "الموقع كله",
  "fields": {
    "type": "نوع المعدّة",
    "place": "المكان",
    "tag": "الرمز التعريفي",
    "brand": "العلامة التجارية",
    "model": "الطراز",
    "brandModel": "العلامة والطراز",
    "serial": "الرقم التسلسلي",
    "installedOn": "تاريخ التركيب",
    "warrantyUntil": "الضمان حتى",
    "condition": "الحالة الفنية",
    "product": "صنف الكتالوج",
    "notes": "ملاحظات",
    "keyField": "المواصفة الأساسية",
    "lastService": "آخر صيانة",
    "status": "الحالة",
    "count": "العدد",
    "position": "الموضع",
    "warranty": "الضمان"
  },
  "place": {
    "search": "ابحث عن مكان",
    "empty": "لا يوجد مكان مطابق."
  },
  "list": {
    "title": "المعدّات",
    "titleAt": "المعدّات في {{place}}",
    "add": "إضافة معدّة",
    "addSeveral": "إضافة عدة معدّات متطابقة",
    "copy": "نسخ المعدّات إلى أماكن أخرى…",
    "printLabels": "طباعة الملصقات",
    "printSelected_zero": "طباعة {{n}} ملصق",
    "printSelected_one": "طباعة ملصق واحد",
    "printSelected_two": "طباعة ملصقين",
    "printSelected_few": "طباعة {{n}} ملصقات",
    "printSelected_many": "طباعة {{n}} ملصقاً",
    "printSelected_other": "طباعة {{n}} ملصق",
    "more": "إجراءات أخرى للمعدّات",
    "moreFor": "إجراءات أخرى لـ {{name}}",
    "selectAll": "تحديد كل المعدّات",
    "select": "تحديد {{name}}",
    "actions": "الإجراءات",
    "empty": "لا معدّات هنا بعد.",
    "emptyBody": "أضف المعدّات المركّبة هنا: وحدات التكييف وطفايات الحريق والمضخات.",
    "neverServiced": "لم تُصن بعد",
    "open": "فتح",
    "edit": "تعديل",
    "reportFault": "الإبلاغ عن عطل",
    "printLabel": "طباعة الملصق",
    "showFinal": "إظهار المستبدلة والمزالة",
    "openJob": "أمر مفتوح {{number}}",
    "search": "ابحث بالرمز التعريفي أو المكان أو الموضع أو العلامة التجارية أو الطراز",
    "clearSearch": "مسح البحث",
    "outOfOrderOnly": "المعطلة فقط",
    "emptyFiltered": "لا معدات مطابقة.",
    "clearFilters": "مسح عوامل التصفية",
    "emptyArchived": "هذا الموقع مؤرشف: لا يمكن إضافة معدّات إليه."
  },
  "drawer": {
    "addTitle": "إضافة معدّة",
    "bulkTitle": "إضافة عدة معدّات متطابقة",
    "bulkDescription": "تأخذ كل معدّة رمزاً تعريفياً خاصاً بها، مرقّماً ببادئة نوعها.",
    "editTitle": "تعديل {{tag}}",
    "replaceTitle": "استبدال {{tag}}",
    "replaceDescription": "تُركّب الوحدة الجديدة في المكان نفسه، وتبقى {{tag}} في السجل مستبدلةً مع سجلّها.",
    "sections": {
      "what": "ما هي",
      "identity": "المكان والتعريف",
      "dates": "التواريخ والحالة الفنية",
      "more": "الصنف والملاحظات"
    },
    "chooseType": "اختر النوع",
    "noTypes": "لا توجد أنواع معدّات بعد. اطلب من المسؤول إضافتها من الإعدادات › أنواع المعدات.",
    "tagHint": "اتركه فارغاً ليُرقّم تلقائياً.",
    "tagAuto": "تلقائي ({{prefix}}-…)",
    "tagAutoPlain": "تلقائي",
    "countHint": "حتى {{max}} في المرة الواحدة.",
    "productHint": "طراز الكتالوج، إن كان مما نبيعه.",
    "productPlaceholder": "ابحث في الكتالوج…",
    "clearProduct": "مسح",
    "replaceNote": "سبب الاستبدال",
    "replaceNotePlaceholder": "تعطّل الضاغط ولا يمكن إصلاحه",
    "save": "حفظ المعدّة",
    "saveBulk_zero": "إضافة {{n}} معدّة",
    "saveBulk_one": "إضافة معدّة واحدة",
    "saveBulk_two": "إضافة معدّتين",
    "saveBulk_few": "إضافة {{n}} معدّات",
    "saveBulk_many": "إضافة {{n}} معدّة",
    "saveBulk_other": "إضافة {{n}} معدّة",
    "saveReplace": "استبدال المعدّة",
    "errors": {
      "type": "اختر نوع المعدّة.",
      "required": "مطلوب.",
      "number": "أدخل رقماً.",
      "choice": "اختر أحد الخيارات.",
      "count": "أدخل العدد، من 1 إلى {{max}}.",
      "tagFormat": "استخدم الحروف والأرقام و . _ - / فقط.",
      "tagTaken": "هذا الرمز التعريفي مستخدم لمعدّة أخرى. اختر غيره، أو اتركه فارغاً ليُرقّم تلقائياً.",
      "yesNo": "اختر نعم أو لا.",
      "date": "أدخل تاريخاً.",
      "text": "أدخل نصاً.",
      "warranty": "لا يمكن أن ينتهي الضمان قبل تاريخ التركيب.",
      "placeArchived": "هذا المكان مؤرشف. اختر غيره.",
      "typeArchived": "نوع المعدّة هذا مؤرشف. اختر غيره.",
      "variant": "اختر منتجاً من الكتالوج.",
      "productSerial": "هذا الرقم التسلسلي ليس لهذا المنتج من الكتالوج.",
      "siteArchived": "هذا الموقع مؤرشف: استعده قبل إضافة معدّاته أو نقلها.",
      "tooLong": "النص طويل: اختصره.",
      "check": "راجع هذه القيمة."
    },
    "positionHint": "لتمييزها عن مثيلاتها في المكان نفسه.",
    "positionPlaceholder": "غرفة النوم 2",
    "discardTitle": "تجاهل التغييرات غير المحفوظة؟",
    "discardBody": "سيضيع ما أدخلته في هذه المعدّة.",
    "discard": "تجاهل التغييرات",
    "keepEditing": "متابعة التعديل",
    "noTypesCreate": "لا توجد أنواع معدّات بعد. أضف نوعاً من «نوع معدّة جديد» في القائمة أعلاه.",
    "siteArchivedPlace": "الموقع مؤرشف: تبقى معدّاته في أماكنها."
  },
  "toast": {
    "added": "أُضيفت المعدّة {{tag}}",
    "addedMany_zero": "لم تُضف أي معدّة",
    "addedMany_one": "أُضيفت معدّة واحدة",
    "addedMany_two": "أُضيفت معدّتان",
    "addedMany_few": "أُضيفت {{n}} معدّات",
    "addedMany_many": "أُضيفت {{n}} معدّة",
    "addedMany_other": "أُضيفت {{n}} معدّة",
    "updated": "حُفظت المعدّة {{tag}}",
    "replaced": "استُبدلت {{tag}}"
  },
  "statusDialog": {
    "note": "ملاحظة",
    "noteRequired": "اذكر سبب الإزالة.",
    "outOfOrder": {
      "title": "تعليم {{tag}} معطّلة؟",
      "body": "تبقى في السجل وفي مكانها، معلَّمة حتى تعود إلى الخدمة.",
      "confirm": "تعليمها معطّلة",
      "done": "عُلّمت {{tag}} معطّلة",
      "placeholder": "لا تبرّد؛ بانتظار ضاغط"
    },
    "inService": {
      "title": "إعادة {{tag}} إلى الخدمة؟",
      "body": "تُعدّ عاملة من جديد.",
      "confirm": "إعادتها إلى الخدمة",
      "done": "عادت {{tag}} إلى الخدمة",
      "placeholder": "أُصلحت في الزيارة SJ-00012 · 2"
    },
    "remove": {
      "title": "إزالة {{tag}}؟",
      "body": "تبقى المعدّة المزالة في السجل ولا يمكن تغييرها بعد ذلك. لتركيب وحدة جديدة استخدم الاستبدال.",
      "confirm": "إزالة المعدّة",
      "done": "أُزيلت {{tag}}",
      "placeholder": "أزالها العميل"
    }
  },
  "copy": {
    "title": "نسخ معدّات {{place}}",
    "description": "تُنسخ معدّاته العاملة إلى كل مكان تختاره: النوع والعلامة والطراز والمواصفات نفسها، برموز تعريفية جديدة. لا تُنسخ الأرقام التسلسلية ولا التواريخ ولا الروابط.",
    "targets": "النسخ إلى",
    "clear": "مسح",
    "summary_zero": "لا أماكن",
    "summary_one": "مكان واحد",
    "summary_two": "مكانان",
    "summary_few": "{{n}} أماكن",
    "summary_many": "{{n}} مكاناً",
    "summary_other": "{{n}} مكان",
    "submit": "نسخ المعدّات",
    "nothing": "لا توجد هنا معدّة في الخدمة، فلا شيء يُنسخ.",
    "chooseTargets": "اختر مكاناً واحداً على الأقل.",
    "willMake_zero": "لن تُضاف أي معدّة.",
    "willMake_one": "تُضاف معدّة واحدة.",
    "willMake_two": "تُضاف معدّتان.",
    "willMake_few": "تُضاف {{n}} معدّات.",
    "willMake_many": "تُضاف {{n}} معدّة.",
    "willMake_other": "تُضاف {{n}} معدّة.",
    "limit": "حتى {{max}} معدّة في النسخة الواحدة.",
    "done_zero": "لم تُنسخ أي معدّة",
    "done_one": "نُسخت معدّة واحدة",
    "done_two": "نُسخت معدّتان",
    "done_few": "نُسخت {{n}} معدّات",
    "done_many": "نُسخت {{n}} معدّة",
    "done_other": "نُسخت {{n}} معدّة",
    "clearSearch": "مسح البحث",
    "byLevel": "اختيار مستوى كامل",
    "everyLevel": "كل أماكن مستوى {{level}} ({{n}})",
    "everyDepth": "كل أماكن المستوى {{depth}} ({{n}})",
    "selectShown_zero": "لا أماكن ظاهرة",
    "selectShown_one": "تحديد المكان الظاهر",
    "selectShown_two": "تحديد المكانين الظاهرين",
    "selectShown_few": "تحديد الأماكن الـ{{n}} الظاهرة",
    "selectShown_many": "تحديد الأماكن الـ{{n}} الظاهرة",
    "selectShown_other": "تحديد الأماكن الـ{{n}} الظاهرة",
    "perPlace": "المعدّات العاملة هنا التي تُنسخ إلى كل مكان تختاره: {{n}}.",
    "tooMany": "سينتج عن ذلك {{n}} معدّة، والحد {{max}} في النسخة الواحدة. اختر أماكن أقل.",
    "errors": {
      "tooMany": "سينتج عن ذلك أكثر من {{max}} معدّة في النسخة الواحدة. اختر أماكن أقل.",
      "archived": "أُرشف بعض هذه الأماكن في أثناء ذلك. اختر غيرها.",
      "itself": "اختر أماكن غير هذا المكان.",
      "check": "راجع الأماكن المختارة."
    }
  },
  "page": {
    "title": "المعدّة",
    "registerOff": "سجل المعدّات متوقف من الإعدادات › أوامر الخدمة. تبقى سجلاته، لكن لا يمكن تغييرها.",
    "final": {
      "REPLACED": "استُبدلت هذه المعدّة. تبقى في السجل مع سجلّها ولا تتغير بعد الآن.",
      "REMOVED": "أُزيلت هذه المعدّة. تبقى في السجل مع سجلّها ولا تتغير بعد الآن."
    },
    "openSuccessor": "فتح {{tag}}",
    "identity": "التعريف",
    "details": "مواصفات {{type}}",
    "noDetails": "ليس لهذا النوع مواصفات إضافية.",
    "history": "السجل",
    "photos": "الصور والمستندات",
    "sections": "أقسام المعدّة",
    "underWarranty": "حتى {{date}}",
    "warrantyEnded": "انتهى في {{date}}",
    "lastService": "{{date}} · {{number}}",
    "replaces": "بديلة عن",
    "replacedBy": "استُبدلت بـ",
    "actions": {
      "reportFault": "الإبلاغ عن عطل",
      "edit": "تعديل",
      "outOfOrder": "تعليمها معطّلة",
      "backInService": "إعادتها إلى الخدمة",
      "replace": "استبدال",
      "printLabel": "طباعة الملصق",
      "remove": "إزالة"
    },
    "openJob": "أمر مفتوح",
    "detailsFailed": "تعذّر تحميل بيانات النوع."
  },
  "history": {
    "empty": "لم يُسجَّل شيء لهذه المعدّة بعد.",
    "job": "أمر خدمة",
    "visit": "زيارة",
    "visitOn": "زيارة يوم {{date}}",
    "workPerformed": "العمل المنجز",
    "findings": "الملاحظات الفنية",
    "statusChanged": "تغيّرت الحالة",
    "replacedBy": "استُبدلت بـ",
    "replaces": "بديلة عن",
    "created": "أُضيفت إلى السجل",
    "note": "ملاحظة",
    "by": "بواسطة {{name}}",
    "check": "فحص",
    "results": "القراءات والفحوص",
    "checkReason": "السبب",
    "faultJob": "أمر العطل"
  },
  "labels": {
    "title": "ملصقات المعدّات",
    "subtitle": "كل رمز تعريفي كباركود، مع النوع والموقع والمكان.",
    "back": "رجوع",
    "print_zero": "طباعة {{n}} ملصق",
    "print_one": "طباعة ملصق واحد",
    "print_two": "طباعة ملصقين",
    "print_few": "طباعة {{n}} ملصقات",
    "print_many": "طباعة {{n}} ملصقاً",
    "print_other": "طباعة {{n}} ملصق",
    "size": "مقاس الملصق",
    "sizes": {
      "roll50x25": "لفة 50 × 25 ملم",
      "roll38x25": "لفة 38 × 25 ملم",
      "a4x24": "ورقة A4، ‏24 ملصقاً (70 × 37 ملم)"
    },
    "copies": "عدد النسخ من كل ملصق",
    "copiesHint": "من 1 إلى {{max}}.",
    "none": "لا معدّات للطباعة.",
    "unprintable_zero": "كل الرموز قابلة للطباعة كباركود.",
    "unprintable_one": "رمز واحد لا يمكن رسمه كباركود.",
    "unprintable_two": "رمزان لا يمكن رسمهما كباركود.",
    "unprintable_few": "{{n}} رموز لا يمكن رسمها كباركود.",
    "unprintable_many": "{{n}} رمزاً لا يمكن رسمها كباركود.",
    "unprintable_other": "{{n}} رمز لا يمكن رسمها كباركود.",
    "preview": "معاينة الملصقات",
    "language": "لغة الملصق",
    "languageHint": "تُطبع أسماء الأنواع والأماكن بهذه اللغة.",
    "copiesError": "أدخل عدداً صحيحاً من 1 إلى {{max}}.",
    "chooseAssets": "اختر المعدات المراد طباعتها: افتح موقعاً، وحدّد معداته، ثم اختر «طباعة الملصقات».",
    "openSites": "فتح المواقع",
    "retry": "إعادة المحاولة",
    "someFailed_zero": "تعذّر تحميل {{n}} معدّة: ملصقاتها غير موجودة.",
    "someFailed_one": "تعذّر تحميل معدّة واحدة: ملصقها غير موجود.",
    "someFailed_two": "تعذّر تحميل معدّتين: ملصقاهما غير موجودين.",
    "someFailed_few": "تعذّر تحميل {{n}} معدّات: ملصقاتها غير موجودة.",
    "someFailed_many": "تعذّر تحميل {{n}} معدّة: ملصقاتها غير موجودة.",
    "someFailed_other": "تعذّر تحميل {{n}} معدّة: ملصقاتها غير موجودة.",
    "truncated": "تُطبع أول {{max}} من {{total}} معدّة. اطبع الباقي مكاناً تلو الآخر."
  },
  "lookup": {
    "label": "البحث عن معدّة برمزها التعريفي",
    "placeholder": "الرمز التعريفي، مثل AC-00012",
    "submit": "بحث",
    "notFound": "لا توجد معدّة بهذا الرمز التعريفي.",
    "description": "اكتب الرمز التعريفي أو امسحه ضوئياً لفتح المعدّة."
  },
  "job": {
    "place": "المكان في الموقع",
    "placeHint": "أين يقع العمل داخل الموقع.",
    "assets": "المعدّات",
    "noAssetsHere": "لا معدّات مسجّلة هنا",
    "assetsPlaceholder": "اختر المعدّات",
    "assetsSearch": "ابحث بالرمز أو النوع",
    "assetsEmpty": "لا توجد معدّة مطابقة.",
    "assetsClear": "مسح",
    "assetsSummary_zero": "لا معدّات",
    "assetsSummary_one": "معدّة واحدة",
    "assetsSummary_two": "معدّتان",
    "assetsSummary_few": "{{n}} معدّات",
    "assetsSummary_many": "{{n}} معدّة",
    "assetsSummary_other": "{{n}} معدّة",
    "groupChecked": "فُحصت {{n}}",
    "chosen": "المعدّات المختارة",
    "remove": "إزالة {{name}}",
    "searching": "جارٍ البحث…",
    "cutOff": "تظهر أول {{n}} من {{total}}: اكتب المزيد لتضييق القائمة.",
    "siteChanged": "أُزيل المكان والمعدّات المختارة لأنها تتبع الموقع السابق.",
    "assetsFailed": "تعذّر تحميل المعدات.",
    "facts": {
      "warranty": "في الضمان حتى {{date}}",
      "openJob": "أمر مفتوح {{number}}",
      "openJobs_zero": "أمر مفتوح {{number}}",
      "openJobs_one": "أمر مفتوح {{number}} وأمر آخر",
      "openJobs_two": "أمر مفتوح {{number}} وأمران آخران",
      "openJobs_few": "أمر مفتوح {{number}} و{{n}} أوامر أخرى",
      "openJobs_many": "أمر مفتوح {{number}} و{{n}} أمرًا آخر",
      "openJobs_other": "أمر مفتوح {{number}} و{{n}} أمر آخر",
      "lastService": "آخر صيانة {{date}}"
    }
  },
  "visit": {
    "title": "المعدّات",
    "accessNotes": "الوصول",
    "none": "لم تُحدَّد معدّات لهذا الأمر."
  },
  "errors": {
    "CODE_TAKEN": "هذا الرمز مستخدم. اختر غيره.",
    "TAG_TAKEN": "هذا الرمز التعريفي مستخدم لمعدّة أخرى. اختر غيره، أو اتركه فارغاً ليُرقّم تلقائياً.",
    "PLACE_TOO_DEEP": "هذا أعمق مما تسمح به مستويات الموقع.",
    "SITE_LIMIT": "بلغ الموقع الحد الأقصى للأماكن.",
    "PLACE_NAME_TAKEN": "يوجد مكان مجاور بالاسم نفسه.",
    "PLACE_CYCLE": "لا يمكن نقل مكان تحت نفسه أو تحت مكان داخله.",
    "NOT_OF_SITE": "هذا المكان أو المعدّة تابع لموقع آخر. اختر من أماكن هذا الموقع ومعدّاته.",
    "PLACE_HAS_ASSETS": "ما زالت فيه معدّات في الخدمة. انقلها أو أزلها أولاً.",
    "ASSET_FINAL": "استُبدلت هذه المعدّة أو أُزيلت، فلا يمكن تغييرها.",
    "TEMPLATE_IN_USE": "تستخدم مواقعُ هذا القالب، فلا يمكن تغيير عدد مستوياته.",
    "IMPORT_STALE": "تغيّر الملف أو الموقع منذ المعاينة. عاين الملف من جديد.",
    "ASSETS_OFF": "سجل المعدّات متوقف من الإعدادات › أوامر الخدمة."
  },
  "fault": {
    "openJob": "الأمر {{number}} مفتوح بالفعل على هذه المعدّة",
    "openJobBody": "يمكنك فتح أمر جديد إن كان العطل مختلفاً.",
    "openJobLink": "فتح {{number}}",
    "occupant": "الساكن:",
    "useOccupant": "اعتماد الساكن جهةً للتواصل"
  }
}
